import { DASHBOARD_PATH } from 'scenes/Dashboard/Dashboard.routes'

export const SEARCH_ENGINE_PATH = `${DASHBOARD_PATH}/search-engine`
